import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            网站分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
            八大核心分类，覆盖工作学习生活全场景，快速定位你需要的资源
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-11 h-11 md:w-12 md:h-12 rounded-xl ${cat.color} flex items-center justify-center mb-3 md:mb-4 transition-transform group-hover:scale-105`}>
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
              <div className="flex items-center gap-1 mt-3 text-xs text-foreground-400">
                <span>{cat.count} 个网站</span>
                <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 transition-transform"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}